// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__34oPX"};